import axios from 'axios'
import Vue from 'vue'
import authHeader from './auth-header'
import Config from '../../config'

if (localStorage.getItem('gpsServers')) {
  Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
} else {
  Vue.prototype.$gpsServers = Config.gpsServers
}
if (localStorage.getItem('apiServers')) {
  Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
  Vue.prototype.$apiServers = Config.apiServers
}
const API_URL = `${Vue.prototype.$apiServers.url}`
const SOCKET_SERVER_1_URL = `${Vue.prototype.$gpsServers.server1.url}`

export class DeviceService {
  // eslint-disable-next-line class-methods-use-this
  getList() {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/user/device/list`, {}, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getAll(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/device/list`, data, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getAllByUserId(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/device/getByUserId`, data, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getAllByResellerId(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/device/getByResellerId`, data, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // گرفتن مقادیر lastStatus و notificationSettings ...
  // eslint-disable-next-line class-methods-use-this
  getServerDeviceStatusAndSettings(payload) {
    const promise = axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/status-and-settings`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line consistent-return,class-methods-use-this
  sendCommand(payload) {
    const { imei, commandName } = payload
    const promise = axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/command`, {
      imei,
      commandName,
    }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getPositions(data) {
    const promise = axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/position`, data, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getAlarm(data) {
    const promise = axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/alarm`, data, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getById(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/user/device/byId`, { id: data.id }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  add(payload) {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/device/add`, payload, { headers: authHeader() })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  addXlm(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$apiServers.url}/admin/device/add-list`, payload, { headers: authHeader() })
        .then(response => {
          resolve(response.data)
          if (response.data.status === 'success') {
            axios.post(`${Vue.prototype.$gpsServers.server1.url}/admin/device/add-list`, response.data.result, { headers: authHeader() })
              .then(res => {
                resolve(res.data)
              })
              .catch(() => reject(new Error('add error.')))
          } else {
            resolve(response.data)
          }
        })
        .catch(() => reject(new Error('add error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  addToUser(payload) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$gpsServers.server1.url}/device`, {
        imei: payload.imei,
        userId: payload.uid,
        resellerId: payload.resellerId,
      }, { headers: authHeader() })
        .then(response => {
          if (response.data.status === 'success') {
            axios.post(`${Vue.prototype.$apiServers.url}/admin/device/addToUser`, payload, { headers: authHeader() })
              .then(res => resolve(res.data))
              .catch(() => reject(new Error('Confirm error.')))
          } else {
            resolve(response.data)
          }
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeUser(payload) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$gpsServers.server1.url}/changeUser`, {
        imei: payload.imei,
        uId: payload.customerId,
        resellerId: payload.resellerId,
      }, { headers: authHeader() })
        .then(response => {
          if (response.data.status === 'success') {
            axios.post(`${Vue.prototype.$apiServers.url}/admin/device/changeUser`, {
              imei: payload.imei,
              customerId: payload.customerId,
              resellerId: payload.resellerId,
            }, { headers: authHeader() })
              .then(res => {
                resolve(res.data)
              })
              .catch(() => reject(new Error('Confirm error.')))
          } else {
            resolve(response.data)
          }
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeReseller(payload) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$gpsServers.server1.url}/device`, {
        imei: payload.imei,
        userId: payload.customerId,
        resellerId: payload.resellerId,
      }, { headers: authHeader() })
        .then(response => {
          if (response.data.status === 'success') {
            axios.post(`${Vue.prototype.$apiServers.url}/admin/device/changeReseller`, {
              imei: payload.imei,
              resellerId: payload.resellerId,
            }, { headers: authHeader() })
              .then(res => {
                resolve(res.data)
              })
              .catch(() => reject(new Error('Confirm error.')))
          } else {
            resolve(response.data)
          }
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeModel(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$apiServers.url}/admin/device/changeModel`, payload, { headers: authHeader() })
        .then(res => {
          resolve(res.data)
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeName(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$apiServers.url}/admin/device/changeName`, payload, { headers: authHeader() })
        .then(res => resolve(res.data))
        .catch(() => reject(new Error('Error while updating device name.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeTitle(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$apiServers.url}/user/device/changeTitle`, {
        imei: payload.imei,
        title: payload.title,
        category: payload.category,
      }, { headers: authHeader() })
        .then(res => {
          resolve(res.data)
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  changeSim(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$apiServers.url}/user/device/changeSim`, {
        imei: payload.imei,
        sim: payload.sim,
      }, { headers: authHeader() })
        .then(res => {
          resolve(res.data)
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // کنترل شماره imei
  // eslint-disable-next-line class-methods-use-this
  check(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/user/device/check`, payload, { headers: authHeader() })
      // eslint-disable-next-line consistent-return
      .then(response => {
        if (response.data.status === 'success') {
          // console.log('Device checked: ', response)
        }
        return response.data
      })
  }

  // ارسال پیامک تنظیم به دستگاه ردیاب
  // eslint-disable-next-line class-methods-use-this
  configure(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/user/device/configure`, payload, { headers: authHeader() })
      .then(response => {
        if (response.data.status === 'success') {
          // console.log('Configure checked: ', response)
        }
        return response.data
      })
  }

  // بررسی پاسخ سیم کارت
  configureStatus(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/user/device/configure-status`, payload, {
        headers: authHeader(),
        timeout: 4400,
      })
      .then(response => {
        if (response.data.status === 'success') {
          // console.log('Configure status checked: ', response)
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  confirm(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$gpsServers.server1.url}/device`, {
        imei: payload.imei,
        userId: payload.userId,
        resellerId: payload.resellerId,
        title: payload.title,
        category: payload.category,
      }, { headers: authHeader() })
        .then(response => {
          if (response.data.status === 'success') {
            axios.put(`${Vue.prototype.$apiServers.url}/user/device`, {
              imei: payload.imei,
              sim: payload.sim,
              title: payload.title,
              category: payload.category,
            }, { headers: authHeader() })
              .then(res => {
                resolve(res.data)
              })
              .catch(() => reject(new Error('Confirm error.')))
          } else {
            resolve(response.data)
          }
        })
        .catch(() => reject(new Error('Confirm error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  notificationSettings(data) {
    const promise = axios.put(`${Vue.prototype.$gpsServers.server1.url}/device/notification/settings`,
      data, { headers: authHeader() })

    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  exportExcel(filter = null) {
    return new Promise((resolve, reject) => {
      // Build query params based on filter
      const params = filter ? { filter } : {}

      axios.get(`${Vue.prototype.$apiServers.url}/admin/device/export-excel`, {
        headers: authHeader(),
        params,
        responseType: 'blob', // Important for handling file downloads
      })
        .then(response => {
          // Create a blob URL for the Excel file
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const url = window.URL.createObjectURL(blob)

          // Create a temporary link and trigger the download
          const link = document.createElement('a')
          link.href = url

          // Dynamic filename based on filter
          const filterSuffix = filter ? `-${filter}` : ''
          link.setAttribute('download', `device-report${filterSuffix}.xlsx`)

          document.body.appendChild(link)
          link.click()

          // Clean up
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)

          resolve({ status: 'success' })
        })
        .catch(error => {
          // console.error('Export Excel error:', error)
          reject(new Error('Export excel error.'))
        })
    })
  }

  // eslint-disable-next-line class-methods-use-this
  delete(payload) {
    // console.log(payload.imei)
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/delete`, {
        imei: payload.imei,
      }, { headers: authHeader() })
        .then(response => {
          if (response.data.status === 'success') {
            axios.post(`${Vue.prototype.$apiServers.url}/admin/device/delete`,
              {
                imei: payload.imei,
              },
              { headers: authHeader() })
              .then(res => {
                resolve(res.data)
              }).catch(() => reject(new Error('delete error.')))
          } else {
            resolve(response.data)
          }
        }).catch(() => reject(new Error('delete error.')))
    })
  }

  // eslint-disable-next-line class-methods-use-this
  getStatistics() {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/admin/device/statistics`, {}, { headers: authHeader() })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  disableExpiredDevices(limit = null) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/admin/device/disable-expired`, { limit }, { headers: authHeader() })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  toggleStatus(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/admin/device/toggle-status`, payload, { headers: authHeader() })
      .then(response => response.data)
  }
}
export default new DeviceService()
